/* eslint-disable */
require('./icon_ai')
require('./icon_ai_blue')
require('./icon_cancle')
require('./icon_copy')
require('./icon_download_done')
require('./icon_download_new')
require('./icon_download')
require('./icon_file_doc')
require('./icon_file_hwp')
require('./icon_file_img')
require('./icon_file_pdf')
require('./icon_file_ppt')
require('./icon_file_txt')
require('./icon_file_xls')
require('./icon_material_equalize_custom')
require('./icon_service_alarm')
require('./icon_service_alertnow')
require('./icon_service_approval')
require('./icon_service_asset_management')
require('./icon_service_cost_management')
require('./icon_service_dbqcs')
require('./icon_service_devops')
require('./icon_service_monitoring')
require('./icon_service_portal')
require('./icon_service_project')
require('./icon_service_resale')
require('./icon_service_service_request')
require('./icon_service_whatap')
require('./icon_upload')
require('./icon_vendor_alibaba')
require('./icon_vendor_aws')
require('./icon_vendor_azure')
require('./icon_vendor_gcp')
require('./icon_vendor_idc')
require('./icon_warning_amber')
require('./logo')
require('./icon_open_popup')



// WEBPACK FOOTER //
// ./src/components/icons/index.js